// extracted by mini-css-extract-plugin
export default {"box":"sponsor-panel-description_box__193qN","annotationTextHeading":"sponsor-panel-description_annotationTextHeading__r8h1W","emailText":"sponsor-panel-description_emailText__0fK71"};